// import '@vimeo/player';
// import Vimeo from '@vimeo/player';
// import Player from '@vimeo/player';
// import * as Vimeo from "@vimeo/player";

const playingClass = "playing",
      mutedClass = "muted",
      hasCCClass = "has-cc"; // binary for testing purposes; in real use case we'd want this as a data attribute or something to distinguish which text track is playing

const wrapper = document.querySelector('.vimeo-wrapper');
const iframe = document.querySelector('.vimeo-video');
if (iframe) {
  const player = new Vimeo.Player(iframe);
  const controls = {
    play: document.querySelector('.vimeo-play'),
    mute: document.querySelector('.vimeo-mute'),
    cc: document.querySelector('.vimeo-cc')
  };

  player.pause();
  player.setCurrentTime(0);
  // Load player in background mode then immediately pause to get around needing user to click the video before the play button will work.
  // Otherwise we can append `controls=0` instead of `background=1` (pick one or the other method depending on whether we want to require user interaction before playback or not)
  controls.play.addEventListener('click', togglePlay);

  player.getMuted().then(function(muted) {
    if (muted) {
      wrapper.classList.add(mutedClass);
    }
  });

  // controls.mute.addEventListener('click', toggleMute);
  // controls.cc.addEventListener('click', toggleCC);

  wrapper.addEventListener('click', togglePlay);

  player.on('play', function(){
    wrapper.classList.add(playingClass);
  });

  player.on('pause', function(){
    wrapper.classList.remove(playingClass);
  });

  player.on('texttrackchange', function(data){
    if (data.kind === null) {
      wrapper.classList.remove(hasCCClass);
    }
    else {
      wrapper.classList.add(hasCCClass);
    }
  });

  function togglePlay() {
      if (wrapper.classList.contains(playingClass)) {
          player.pause();
      }
      else {
          player.play();
      }
  }

  function toggleMute() {
    if (wrapper.classList.contains(mutedClass)) {
      player.setMuted(false);
      wrapper.classList.remove(mutedClass);
    }
    else {
      player.setMuted(true);
      wrapper.classList.add(mutedClass);
    }
  }

  function toggleCC() {
    // en only for test purposes
    if (wrapper.classList.contains(hasCCClass)) {
      player.disableTextTrack();
    }
    else {
      player.enableTextTrack('en');
    }
  }
}
